/* global axios */
import ApiClient from '../ApiClient';

class WhatsappChannel extends ApiClient {
  constructor() {
    super('whatsapp', { accountScoped: true });
  }

  createEmbeddedSignup(params) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, params);
  }

  reauthorizeWhatsApp({ inboxId, ...params }) {
    return axios.post(`${this.baseUrl()}/whatsapp/authorization`, {
      ...params,
      inbox_id: inboxId,
    });
  }

  getTemplateMessageLimits(targetDate = null) {
    const params = targetDate ? { target_date: targetDate } : {};
    return axios.get(`${this.baseUrl()}/whatsapp/template_message_limits`, { params });
  }

  estimateCampaignAudience(labelIds = []) {
    const params = new URLSearchParams();
    labelIds.forEach(id => params.append('label_ids[]', id));
    const qs = params.toString();
    const url = `${this.baseUrl()}/whatsapp/campaigns/estimate${qs ? `?${qs}` : ''}`;
    return axios.get(url);
  }
}

export default new WhatsappChannel();
